export const EXTRA_QUERY_KEYS = {
  PRINT: ['commonDocsTablePrint'],
  EXPORT: ['commonDocsTableExport'],
  DIFF: ['commonDocsTableDiff']
};
